import { render, staticRenderFns } from "./objectionAndReply.vue?vue&type=template&id=766bf2fe&scoped=true"
import script from "./objectionAndReply.vue?vue&type=script&lang=js"
export * from "./objectionAndReply.vue?vue&type=script&lang=js"
import style0 from "./objectionAndReply.vue?vue&type=style&index=0&id=766bf2fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766bf2fe",
  null
  
)

export default component.exports